/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { getID } from "src/libs/utilities"
import AnimationPanel from "../landing/landing-edit/animation-panel"
import BackgroundForm from "../landing/landing-edit/background/BackgroundForm"
import BorderPanel from "../landing/landing-edit/border"
import Delimiter from "../landing/landing-edit/delimiter/Delimiter"
import FillPanel from "../landing/landing-edit/fill"
import LandingSettingForm from "../landing/landing-edit/landing-setting-form/LandingSettingForm"
import LandingDataPanel from "../landing/landing-edit/LandingDataPanel"
import { Layers } from "../landing/landing-edit/layers-form/Layers"
import { Meat } from "../landing/landing-edit/meat-form/MeatForm"
import Title from "../landing/landing-edit/title-form/Title"
import FloatPanel from "./FloatPanel"
import { IPanel, IPanelConsole, IPanelLayout, PanelData } from "./interface"
import PanelConsole from "./PanelConsole"
import PanelMembrane from "./PanelMembrane"
import { IPanelStore, usePanelStore } from "./store"

/* Protopia Ecosystem component */
export interface IPanelLayoutProps {
   layoutId: ID
   layoutElement: Element | JSX.Element
   initData: IPanelLayout
} 

export const allPanelData = (): any => {
    return {
        // zoom: {
        //     title: "Zoom",
        //     icon: "/assets/img/landing/zoom.svg",
        //     component: <Zoom />,
        // },
        "landing-data": {
            title: "Landing Data",
            icon: "/assets/img/landing/json-file.svg",
            component: <LandingDataPanel />,
        },
        sections: {
            component: <Layers />,
            title: "Sections",
            icon: "/assets/img/landing/layers.svg",
        },
        "landing-settings" :  {
            component: <LandingSettingForm />,
            title: "Landing settings",
            icon: "/assets/img/landing/landing-settings.svg",
        },
        "meat" :   {
            component: <Meat />,
            title: "Meat",
            icon: "/assets/img/landing/meat.svg",
        },
        "float" :  {
            component: <>FLOAT</>,
            title: "Float",
            icon: "/assets/img/landing/float.svg",
        },
        "title" :  {
            component: <Title />,
            title: "Title",
            icon: "/assets/img/landing/html.svg",
        },
        "background" :  {
            component: <BackgroundForm />,
            title: "Background",
            icon: "/assets/img/landing/background.svg",
        },
        "delimiter" :  {
            component: <Delimiter />,
            title: "Delimiter",
            icon: "/assets/img/landing/divide.svg",
        },
        // "cards" :  {
        //     component: <>cards</>,
        //     title: "Cards",
        //     icon: "/assets/img/landing/cards-blank.svg",
        // },
        // "card-template" :  { 
        //     title:`Card template's Fields`,
        //     icon: "/assets/img/landing/rows.svg",
        //     component: <CardsFieldsPanelContent />
            
        // },
        // "card-template-preview" :  { 
        //     title: `Card template preview`,
        //     icon: "/assets/img/landing/table-layout.svg",
        //     component: <CardTemplateForm />
            
        // },
        // "single-field": {
        //     title: `Card field`,
        //     icon: "/assets/img/landing/rows.svg",
        //     component: <SingleCardFieldPanelContent />
        // },
        // "transform": {
        //     title: `Transform`,
        //     icon: "/assets/img/landing/transform.svg",
        //     component: <Transform />
        // },
        "fill": {
            title: `FILL`,
            icon: "/assets/img/landing/fill.svg",
            component: <FillPanel />
        },
        "border": {
            title: `Border`,
            icon: "/assets/img/landing/borders.svg",
            component: <BorderPanel />
        },
        "animation": {
            title: `animation`,
            icon: "/assets/img/landing/animation.svg",
            component: <AnimationPanel />
        },
    }
}

const PanelLayout = (props: IPanelLayoutProps): JSX.Element => {
    const width                     = usePanelStore((state: IPanelStore) => state.width)
    const panelDatas: PanelData[]   = usePanelStore((state: IPanelStore) => state.panelDatas)
    const panels: IPanel[]          = usePanelStore((state: IPanelStore) => state.panels)
    const consoles: IPanelConsole[] = usePanelStore((state: IPanelStore) => state.consoles)
    const float: IPanel[]           = usePanelStore((state: IPanelStore) => state.float)
    const isHidePanels: boolean     = usePanelStore((state: IPanelStore) => state.isHidePanels)

    useEffect(() => { 
        if( !panelDatas.length && !panels.length && !consoles.length && !float.length ) {
            usePanelStore.setState({
                panelDatas: props.initData.panelDatas || [],
                panels: props.initData.panels || [],
                consoles: props.initData.consoles || [],
                float: props.initData.float || [],
            })
        } 
    }, [])

    const onPanelPosition = ( x:number, y: number, w: number, h: number, panelId: ID, consoleId: ID  ) => {
        const state = usePanelStore.getState()
        if( consoleId !== -1 ) {
            const newVal = state.consoles.map((_console: IPanelConsole) => {
                if(consoleId === _console.id ) {
                    return {
                        ..._console,
                        panels: _console.panels.map((panel: IPanel) => {
                            if(panel.id === panelId) {                                
                                // console.log( x, y, w, h, panelId, panel.id, consoleId )
                                return { ...panel, x, y, w, h }   
                            }
                            return panel
                        })
                    }
                }
                return _console
            }) 
            usePanelStore.setState({ consoles: newVal })
        }
        else {
            usePanelStore.setState({ float: [
                ...state.float.map((panel:IPanel) => {
                    if(panel.id === panelId) {  
                        return { ...panel, x, y, w: w || 300, h: h || 300 }
                    }
                    return panel
                })
            ] })
        }
    }
    const onClose = ( panelId: ID ) => { 
        const state = usePanelStore.getState()  
        let _panel: IPanel | undefined = undefined
        usePanelStore.setState({ 
            consoles: state.consoles.map((_console: IPanelConsole) => { 
                return {
                    ..._console,
                    panels: _console.panels.filter((panel: IPanel) => {
                        if(panel.id === panelId) {
                            _panel = panel
                        }
                        return panel.id !== panelId 
                    })
                }
            }).filter((_console: IPanelConsole) => !!_console.panels.length ),
            float: [
                ...state.float.filter( (panel:IPanel) => {
                    if(panel.id === panelId) {
                        _panel = panel
                    }
                    return panel.id !== panelId 
                })
            ]  
        }) 
        if(_panel) {
            usePanelStore.setState({ 
                panels: [...panels, _panel]
            })
        }
    }
    const setActivePanelDataId = (panelDataId: ID, panelId: ID, consoleId: ID) => {
        const state: IPanelStore = usePanelStore.getState()
        if( consoleId === "-1") {
            usePanelStore.setState({ float: state.float.map(panel => {
                    if(panel.id === panelId) {
                        return {
                            ...panel,
                            activeId: panelDataId
                        }
                    }
                    return panel
                })
            })
        }
        else {
            const newVal = state.consoles.map((_console: IPanelConsole) => {
                if(consoleId === _console.id ) {
                    return {
                        ..._console,
                        panels: _console.panels.map(( panel: IPanel ) => {
                            if( panel.id === panelId ) {                                
                                return { 
                                    ...panel, 
                                    activeId: panelDataId,
                                }   
                            }
                            return panel
                        })
                    }
                }
                return _console
            }) 
            usePanelStore.setState({ consoles: newVal })
        }
    }
    const onConsoleClose = ( consoleId: ID, isOpen: boolean ) => {
        const state: IPanelStore = usePanelStore.getState()
        const newVal = state.consoles.map((_console: IPanelConsole) => {
            if(consoleId === _console.id ) {
                return {
                    ..._console,
                    isOpen
                }
            }
            return _console
        }) 
        usePanelStore.setState({ consoles: newVal })
    }
    const onThread = (panelId: ID, consoleId: ID, isTread: boolean, x:number, y: number, w: number, h: number, ) => {
        let _panel : IPanel | undefined
        const state: IPanelStore = usePanelStore.getState()
        if( isTread ) {
            const float = state.float.filter(panel => {
                if(panel.id === panelId) {
                    _panel = { ...panel }
                }
                return panel.id !== panelId
            })
            let consoles: IPanelConsole[] =  [ ...state.consoles ]
            
            if(consoleId === "-1") {
                const id = getID("console")
                const newConsole: IPanelConsole = {
                    id,
                    isOpen: true,
                    panels: [],
                    width: 300
                }
                consoles = [ newConsole, ...consoles ]
                consoleId = id
            }

            consoles = consoles.map((console: IPanelConsole) => {
                const panels = console.id === consoleId
                    ?
                    [
                        ...console.panels,
                        { ..._panel, x, y, w: w || 300, h: h || 300, isTread }
                    ]
                    : 
                    console.panels
                return {
                    ...console,
                    panels
                }
            })
            if(!!_panel ) {
                usePanelStore.setState({
                    float,
                    consoles
                }) 
            }
        }
        else {
            const consoles = state.consoles.map((console: IPanelConsole) => {
                const panels = console.panels.filter(panel => {
                    if(panel.id === panelId) {
                        _panel = { ...panel, x, y, w: w || 300, h: h || 300, isTread }
                    }
                    return panel.id !== panelId 
                })
                return {
                    ...console,
                    panels
                }
            }).filter((console: IPanelConsole) => !!console.panels.length ) 
            if(!!_panel ) {
                usePanelStore.setState({
                    float: [...(state.float || []), _panel],
                    consoles
                }) 
            }
        }
    }
    const onCompact = ( panelId: ID,  consoleId: ID, isCompact: boolean ) => {
        const state: IPanelStore = usePanelStore.getState()
        if( consoleId === "") {
            usePanelStore.setState({ float: state.float.map(panel => {
                    if(panel.id === panelId) {
                        return {
                            ...panel,
                            isOpen: isCompact
                        }
                    }
                    return panel
                })
            })
        }
        else {
            const newVal = state.consoles.map((_console: IPanelConsole) => {
                if(consoleId === _console.id ) {
                    return {
                        ..._console,
                        panels: _console.panels.map(( panel: IPanel ) => {
                            if( panel.id === panelId ) {                                
                                return { 
                                    ...panel, 
                                    isOpen: isCompact
                                }   
                            }
                            return panel
                        })
                    }
                }
                return _console
            }) 
            usePanelStore.setState({ consoles: newVal })
        }
    }
     
    return  !!isHidePanels
        ?
        <></>
        :
        <div className='pe-panel-layout-container'>
            <PanelMembrane />
            {
                consoles.map((cnsl: IPanelConsole) => {
                    return <PanelConsole
                        data={cnsl} 
                        key={cnsl.id} 
                        onPosition={onPanelPosition}
                        onThread={onThread}
                        onCompact={( panelId: ID, isCompact: boolean ) => onCompact(panelId, cnsl.id, isCompact, )}
                        onClose={onClose}
                        onConsoleClose={onConsoleClose}
                        setActivePanelDataId={( panelDataId: ID, panelId: ID ) => setActivePanelDataId(panelDataId, panelId, cnsl.id)}
                    />
                })
            } 
            <FloatPanel 
                data={ float } 
                onPosition={onPanelPosition}
                onThread={onThread}
                onCompact={( panelId: ID, isCompact: boolean ) => onCompact(panelId, "", !isCompact, )}
                onClose={onClose}
                setActivePanelDataId={( panelDataId: ID, panelId: ID ) => setActivePanelDataId( panelDataId, panelId, "-1" )}
            /> 
        </div>
}
export default PanelLayout